import React, { Component } from "react";
import "../styles/components/LoadMore.css";
class LoadMore extends Component {
  render() {
    return (
      <div
        id="container"
        onClick={() => {
          this.props.history.push("/news/" + this.props.id);
        }}
      >
        <button class="learn-more">
          <div class="circle">
            <span class="icon arrow" />
          </div>
          <p class="button-text">Me Shume</p>
        </button>
      </div>
    );
  }
}
export default LoadMore;
